import { combineReducers } from "redux"
import primaryData from "./primaryDataReducer"

export default combineReducers({
    primaryData,
})
